<template lang="pug">
.bloco-potencial-psa
    .bloco-potencial-psa__titulo
        .bloco-potencial-psa__titulo--interno
            span Total de Imóveis:
            span.negrito {{ imoveisValor }}

    .bloco-potencial-psa__conteudo
        .bloco-potencial-psa__conteudo--esquerdo
            span.barra-topo Área de vegetação nativa
            span.valor__negrito {{ areaValor }}

    .bloco-potencial-psa__alinhamento
        .bloco-potencial-psa__alinhamento--conteudo
            span.barra-topo Áreas prioritárias para conservação
            span.valor__negrito {{ areasConservacao }}
        .bloco-potencial-psa__alinhamento--conteudo
            span.barra-topo Número de nascentes
            span.valor__negrito {{ nascentes }}
</template>

<script>
export default {
    name: 'BlocoPotencialPSA',
    props: {
        imoveisValor: {
            type: String,
            default: () => ''
        },
        areaValor: {
            type: String,
            default: () => ''
        },
        areasConservacao: {
            type: String,
            default: () => ''
        },
        nascentes: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-potencial-psa {
    width: 100%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    height: 405px;
    .bloco-potencial-psa__titulo {
        display: flex;
        padding-bottom: 8px;
    }
    .bloco-potencial-psa__titulo--interno {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        width: 80%;
        .negrito {
            font-weight: 600;
            font-size: 20px;
            color: var(--primary);
        }
    }
    .bloco-potencial-psa__conteudo {
        display: flex;
        margin-bottom: 15px;
        &--esquerdo {
            display: flex;
            flex-direction: column;
            min-width: 58%;
        }
        &--direito {
            display: flex;
            flex-direction: column;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .bloco-potencial-psa__alinhamento {
        display: flex;
        flex-direction: column;

        &--conteudo {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .barra-topo::before {
        content: '';
        display: flex;
        width: 24px;
        height: 2px;
        background: var(--secondary-two);
        clear: both;
        margin-bottom: 5px;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
